import Model from '/lib/model'
import currencies from '/lib/currencies'
import { formatMoney } from 'accounting'

export default \
class EventReport extends Model
  @className: 'EventReport'
  constructor: ->
    super arguments...
    @id                           = null
    @tickets_sold                 = null
    @cost_items_sold              = null
    @ticket_items_sold            = null
    @total_sales                  = null
    @net_sales                    = null
    @sales_by_date                = null # [{date: "2013-05-10", rate_id: "...", net_sales: 200}]

  @belongsTo 'listing', model: 'Listing'

  @computed 'baseCurrency', ->
    @listing?.base_currency || 'USD'

  @computed 'amountGross', ->
    formatMoney @total_sales, symbol: currencies[@baseCurrency].replace @baseCurrency, ''

  @computed 'fulfillmentAmount', ->
    formatMoney @net_sales, symbol: currencies[@baseCurrency].replace @baseCurrency, ''
